// datatable related plugins
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { MODE_FORM, tableFormateDate } from "pages/DataFormatInvoice/utils";
import { TYPE_TAX_DEDUCT } from "pages/ReportInvoiceError/helper/functionHelper";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Card, CardBody, Col, Row } from "reactstrap";
import {
  getReportInvoiceList,
  resetDownloadReportInvoice,
  resetReportInvoiceList,
  setColumnVisibleReportInvoiceList,
} from "store/summary-invoice-data/actions";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DetailData from "./DetailData";
import { getInvoiceStatus } from "./helper/functionHelper";
import PDFViewModal from "./modal/PDFViewModal";
import { TYPE_ADJUST_TAX_DEDUCT } from "./utils";
const ListAdjust = props => {
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  const toggleDetailModal = () => {
    setDetailModal(!detailModal);
  };

  const [mode, setMode] = useState("");
  const [pageView, setPageView] = useState(null);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const { type, fileDownload, fileDownloadName } = summaryInvoiceData;
  const { loading, listData, totalCount, columnsVisible, params } =
    summaryInvoiceData.reportInvoiceList;
  const history = useHistory();

  const { t, i18n } = useTranslation(["taxDeduct"]);

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
    }
  }, [type]);

  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  //   useEffect(() => {
  //     switch (type) {
  //       case RELEASE_INVOICE_CYCLES_SUCCESS:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thành công", {
  //           appearance: "success",
  //           autoDismiss: true,
  //         });
  //         toggleHSMSignModal();
  //         dispatch(getReportInvoiceList(params));
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //       case RELEASE_INVOICE_CYCLES_FAIL:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thất bại", {
  //           appearance: "error",
  //           autoDismiss: true,
  //         });
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //     }
  //   }, [type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      dispatch(getReportInvoiceList(params, TYPE_TAX_DEDUCT.ADJUST));
    }
  }, [finalBuInfo]);

  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetReportInvoiceList());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      //   setDataDetail(row);
      //   toggleViewDetailModal();
    },
  };

  const listRowAction = [
    // {
    //   icon: <i className="bx bx-download font-size-18 text-primary" />,
    //   text: "Download file",
    //   conditionVisible: {
    //     resource_id: [],
    //   },
    // },
  ];

  const selectFilterLinkType = {
    [TYPE_ADJUST_TAX_DEDUCT.INCREASE]: "Điều chỉnh tăng",
    [TYPE_ADJUST_TAX_DEDUCT.DECREASE]: "Điều chỉnh giảm",
    [TYPE_ADJUST_TAX_DEDUCT.CHANGE_INFO]: "Điều chỉnh thông tin",
  };

  const initColumns = [
    {
      dataField: "type",
      text: "Loại điều chỉnh",
      formatter: (cellContent, row) => {
        switch (cellContent) {
          case TYPE_ADJUST_TAX_DEDUCT.INCREASE:
            return "Điều chỉnh tăng";
          case TYPE_ADJUST_TAX_DEDUCT.DECREASE:
            return "Điều chỉnh giảm";
          case TYPE_ADJUST_TAX_DEDUCT.CHANGE_INFO:
            return "Điều chỉnh thông tin";
          default:
            return "";
        }
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterLinkType,
        // style: { maxWidth: "140px" },
      }),
    },
    {
      dataField: "bu_code",
      text: "Mã đơn vị",
    },
    {
      dataField: "root_id",
      text: "Id",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => (
        <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
          {cellContent}
        </div>
      ),
      headerStyle: {
        color: "red",
      },
    },

    {
      dataField: "root_khctu",
      text: "Ký hiệu",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => {
        if (cellContent) {
          return String(row?.root_khctu);
        } else {
          return "";
        }
      },
      headerStyle: {
        color: "red",
      },
    },
    {
      dataField: "root_sctu",
      text: "Số CTKT",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => (
        <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
          {cellContent ? cellContent : "Chờ cấp số"}
        </div>
      ),
      headerStyle: {
        color: "red",
      },
    },
    {
      dataField: "root_nlap",
      text: "Ngày lập",
      formatter: (cellContent, row) => tableFormateDate(cellContent),
      headerStyle: {
        color: "red",
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    // {
    //   dataField: "root_note",
    //   text: "Ghi chú",
    //   formatter: (cellContent, row) => (
    //     <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
    //       {cellContent}
    //     </div>
    //   ),
    //   headerStyle: {
    //     color: "red",
    //   },
    // },
    {
      dataField: "action_1",
      text: "",
      formatter: (cellContent, row) => {
        if (row.root_id) {
          return (
            <div className="d-flex gap-2 justify-content-center">
              <i
                onClick={() => {
                  showDetailById(row.root_id);
                }}
                title="Chi tiết CTKT"
                style={{ cursor: "pointer" }}
                className="text-info bx bx-message-square-dots label-icon font-size-20"
              />
              <i
                onClick={() => {
                  showPdfById(row.root_id);
                }}
                title="Bản hiển thị"
                style={{ cursor: "pointer" }}
                className="text-danger bx bxs-file-pdf label-icon font-size-20"
              />
            </div>
          );
        }
      },
    },
    {
      dataField: "child_id",
      text: "Id",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => (
        <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
          {cellContent ? cellContent : "(CTKT TT32)"}
        </div>
      ),
      headerStyle: {
        color: "blue",
      },
    },
    {
      dataField: "child_khctu",
      text: "Ký hiệu",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => {
        if (cellContent) {
          return String(row?.child_khctu);
        } else {
          return "";
        }
      },
      headerStyle: {
        color: "blue",
      },
    },
    {
      dataField: "child_shdon",
      text: "Số CTKT",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => (
        <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
          {cellContent ? cellContent : "Chờ cấp số"}
        </div>
      ),
      headerStyle: {
        color: "blue",
      },
    },
    {
      dataField: "child_nlap",
      text: "Ngày lập",
      formatter: (cellContent, row) => tableFormateDate(cellContent),
      headerStyle: {
        color: "blue",
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    // {
    //   dataField: "child_note",
    //   text: "Ghi chú",
    //   formatter: (cellContent, row) => (
    //     <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
    //       {cellContent}
    //     </div>
    //   ),
    //   headerStyle: {
    //     color: "blue",
    //   },
    // },
    {
      dataField: "action_2",
      text: "",
      formatter: (cellContent, row) => {
        if (row.child_id) {
          return (
            <div className="d-flex gap-2 justify-content-center">
              <i
                onClick={() => {
                  showDetailById(row.child_id);
                }}
                title="Chi tiết CTKT"
                style={{ cursor: "pointer" }}
                className="text-info bx bx-message-square-dots label-icon font-size-20"
              />
              <i
                onClick={() => {
                  showPdfById(row.child_id);
                }}
                title="Bản hiển thị"
                style={{ cursor: "pointer" }}
                className="text-danger bx bxs-file-pdf label-icon font-size-20"
              />
            </div>
          );
        }
      },
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getReportInvoiceList(params, TYPE_TAX_DEDUCT.ADJUST));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getReportInvoiceList(params, TYPE_TAX_DEDUCT.ADJUST));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleReportInvoiceList(field, value));
  };

  const showDetailById = id => {
    setDataDetail({
      id: id,
      mode: MODE_FORM.VIEW,
    });
    toggleDetailModal();
  };

  const CaptionElement = (
    <div
      style={{
        textAlign: "center",
        border: "2px solid #eff2f7",
        borderBottom: "none",
        fontSize: "20px",
        display: "flex",
      }}
    >
      {" "}
      <div
        style={{
          color: "black",
          width: "21.96%",
          padding: "0.5em",
          borderRight: "2px solid #eff2f7",
        }}
      ></div>
      <div
        style={{
          color: "red",
          width: "39.06%",
          padding: "0.5em",
          borderRight: "2px solid #eff2f7",
        }}
      >
        CTKT bị điều chỉnh
      </div>
      <div style={{ color: "blue", flex: 1, padding: "0.5em" }}>
        CTKT điều chỉnh
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách CTKT điều chỉnh</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách CTKT điều chỉnh" + ` (${totalCount})`}
          />
          <Row>
            {/* Detail Modal */}
            <DetailData
              t={t}
              i18n={i18n}
              dataDetail={dataDetail}
              isOpen={detailModal}
              toggle={toggleDetailModal}
              showPdfById={showPdfById}
            />
            {/* PDFViewModal */}
            <PDFViewModal
              isOpen={modalPdfView}
              dataViewDocument={dataViewDocument}
              toggle={togglePdfViewModal}
            ></PDFViewModal>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      caption={CaptionElement}
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    ></RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListAdjust;
